<template>
    <span v-if="invoice===true" class="Invoice-checkbox" :class="computedClass" @click="$emit('click')">
        <span class="check"></span>
    </span>
    <span v-else class="Checkbox" :class="computedClass" @click="$emit('click')">
        <font-awesome-icon class="check" icon="check"/>
    </span>
</template>

<script>
    export default {
        name: 'Checkbox',
        props: {
            disabled: {
                type: Boolean,
                default: false,
            },
            checked: {
                type: Boolean,
                default: false,
            },
            highlightError: {
                type: Boolean,
                default: false,
            },
            invoice: {
                type: Boolean,
                default: false,
                required: false,
            }
        },
        computed: {
            computedClass() {
                return {
                    checked: this.checked,
                    disabled: this.disabled,
                    error: this.highlightError,
                };
            },
        },
        methods: {
            click() {
                this.$emit('click');
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '@/assets/scss/_variables.scss';
    @import "@/assets/scss/bulma/projectBulma.scss";

    .Invoice-checkbox {
        display: block;
        background-color: white;
        width: 20px;
        height: 20px;
        border: solid 1px $primary;
        border-radius: 3px;
        position: relative;
        cursor: pointer;

        .check::before{
            content: "";
            position: relative;
            display: block;
            height: 7px;
            background-color: $primary;
            top: 10px;
            left: 9px;
            width: 15px;
            margin-left: -14px;
            border-radius: 3px;
            -webkit-transform: rotate(45deg);
            transform: rotate(45deg);
            transition: 0.2s ease-out opacity;
            opacity: 0;
        }
        .check::after{
            content: "";
            position: relative;
            display: block;
            bottom: 12px;
            left: 9px;
            width: 7px;
            height: 28px;
            background-color: $primary;
            border-radius: 3px;
            -webkit-transform: rotate(30deg);
            transform: rotate(30deg);
            transition: 0.2s ease-out opacity;
            opacity: 0;
        }

        &.checked{
            .check::before{
                content: "";
                position: relative;
                display: block;
                height: 6.5px;
                background-color: $primary;
                top: 10px;
                left: 9px;
                width: 15px;
                margin-left: -14px;
                border-radius: 4px;
                -webkit-transform: rotate(45deg);
                transform: rotate(45deg);
                opacity: 1;
            }
            .check::after{
                content: "";
                position: relative;
                display: block;
                bottom: 12px;
                left: 9px;
                width: 6.5px;
                height: 28px;
                background-color: $primary;
                border-radius: 4px;
                -webkit-transform: rotate(30deg);
                transform: rotate(30deg);
                opacity: 1;
            }
        }
    }

    .Checkbox {
        cursor: pointer;
        user-select: none;
        padding: 1px 2px;
        background-color: #eee;
        border: solid 1px $primary;
        border-radius: 3px;
        color: #eee;
        font-size: 0.7em;
        transition: 0.1s ease-out background-color;

        &.disabled {
            pointer-events: none;
            opacity: 0.2;
        }

        .check {
            opacity: 0;
            transition: 0.2s ease-out opacity;
        }

        &.checked {
            background-color: $primary;

            .check {
                opacity: 1;
            }
        }

        &.error {
            background-color: red;
        }
    }
</style>
